import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import HeaderNewClear from '../partials/HeaderNewClear.jsx'
import FooterNew from '../partials/FooterNew.jsx'
import initializers from '../../dependencies/initializers.js'



import imgHero from '../../images/hero_img_high_potential.png'
import imgSectionOne from '../../images/img_high_potential_01.png'
import imgSectionTwo from '../../images/img_high_potential_02.png'
import imgSectionThree from '../../images/img_high_potential_03.png'
import imgRoundedRightTop from '../../images/rounded_top_right.png'

import { accesslog, translate } from '../../helpers/global.js'

import { usersGetDetailAsync } from '../../actions/users.js'
import { getWeeklyDemoDataAsync } from '../../actions/global';

class HighPotential extends React.Component {
	constructor(props) {
		super(props)
	}

	async componentDidMount() {
		window.scrollTo(0, 0)
    if (!this.props.weeklyDemoData || !this.props.weeklyDemoData.webinar_link) {
      await this.props.getWeeklyDemoDataAsync();
    }    
	}

  chooseOpt(val) {
		const url_api = initializers.api_host
		  if(val === '1') {
			  if (process.env.NODE_ENV === 'development') {
				window.location = 'http://localhost:3000/'
			} else if (url_api == 'https://beta.astrnt.co') {
	
				window.location = 'https://test.astrnt.co/'
	
			} else {
				window.location = 'https://astrnt.co/'
			}
		  } else {
			  if (process.env.NODE_ENV === 'development') {
				window.location = 'http://localhost:3000/'
			} else if (url_api == 'https://beta.astrnt.co') {
	
				window.location = 'https://test.astrnt.id/'
	
			} else {
				window.location = 'https://astrnt.id/'
			}
		  }
		}

  render() {
    const {
      globalGetLanguages,
      user, weeklyDemoData
    } = this.props
    const renderHTML = (rawHTML: string) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
    return (
			<div id="homepage">
        <HeaderNewClear isOnStatusFor="is-on" />
        <div className="banner ai">
          <section>
            <div className="ban-text high-potential">
              <div className="title-1">Find Future Leaders Early</div>
              <div className="title-1">with Clear Signals</div>              

              <div className='content-desc-technical'>
                Move beyond gut feeling. Use structured tools to identify your next wave of high-<br />
                impact performers.
              </div>

              <div className={`ban-link`}>
                <Link onClick={() => {
                  document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                  accesslog('talent-management/high-potential-identification', 'button_talk_to_an_expert');
                }} className="try">{translate(globalGetLanguages,'BUTTON_TALK_EXPERT')}</Link>
                <a href={weeklyDemoData.webinar_link} target="_blank" className={`request-demo-logged${weeklyDemoData.webinar_link != null ? '' : ' hide'}`}
                  onClick={() => accesslog('talent-management/high-potential-identification', 'button_register_for_demo')}
                >Register for Demo</a>
              </div>
              <div className={`ban-link hide`}>
                <Link onClick={() => document.getElementById('modal_talk_expert').classList.add('show-cta-modal')} className='try'>{translate(globalGetLanguages,'BUTTON_TALK_EXPERT')}</Link>
              </div>
              <a href="#" className="vid-msg">
                <img src={imgHero} />
              </a>
            </div>
          </section>
        </div>


     <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <a href="#" className="vid-msg-right-top">
            <img src={imgRoundedRightTop} />
          </a>

          <section className='flex-container position-relative'>
            <div className='flex-item-left'>
              <div className='vertical-item--center' style={{ margin: '0 50px 0 0' }}>
                <img className='img-100' src={imgSectionOne} />
              </div>
            </div>
            
            <div className='flex-item-right'>
              <div className='vertical-item--center'>
                <div className='sec-desc-point'>
                  <h2 className='m-t-0 m-b-24' style={{ fontWeight: '700' }}>
                    What You Don’t See, You Miss
                  </h2>
                  <p className='m-b-24'>
                    Some employees quietly overdeliver. They learn fast, lead<br /> 
                    informally, and adapt with ease. But without visibility,<br />
                    they often go unrecognised. Promotions go to the loudest,<br /> 
                    not the most capable.
                  </p>
                  <p className='m-b-8'>Common challenges and mistakes:</p>      
                  <ul>
                    <li><i className="fas fa-check" />No clear method to spot early signs of leadership</li>
                    <li><i className="fas fa-check" />High performers and high potentials are often confused</li>
                    <li><i className="fas fa-check" />Lack of structure across departments and business units</li>
                    <li><i className="fas fa-check" />Promotions and fast-tracking based on familiarity</li>
                  </ul>                              
                 
                </div>
              </div>
            </div> 
          </section>
      </div>
    
    <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <section className='flex-container'>
            
            <div className='flex-item-right'>
              <div className='vertical-item--center'>
                <div className='sec-desc'>

                  <h2 className='m-t-0 m-b-24' style={{ fontWeight: '700' }}>
                    What Organisations Are Doing Today
                  </h2>
                  <p className='m-b-24'>
                    Forward-thinking organisations are building systems to<br />
                    identify high potential employees using structured<br />
                    signals. They combine assessment data, manager input,<br /> 
                    and consistent frameworks.
                  </p>
                  <p className='m-b-24'>
                    Rather than waiting for performance reviews, they<br />
                    proactively seek potential based on cognitive ability,<br /> 
                    adaptability, and leadership readiness. These are<br /> 
                    measured through real tasks.
                  </p>                  

                </div>
              </div>
            </div> 
            <div className='flex-item-left'>
              <div className='vertical-item--center'>
                <img className='img-100' src={imgSectionTwo} />
              </div>
            </div>
          </section>
      </div>

     <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <section className='flex-container'>
            <div className='flex-item-left'>
              <div className='vertical-item--center' style={{ margin: '0 50px 0 0' }}>
                <img className='img-100' src={imgSectionThree} />
              </div>
            </div>
            
            <div className='flex-item-right'>
              <div className='vertical-item--center'>
                <div className='sec-desc'>

                  <h2 className='m-t-0 m-b-24' style={{ fontWeight: '700' }}>
                    How ASTRNT Supports High <br />Potential Identification
                  </h2>
                  <p className='m-b-8'>
                    With ASTRNT, companies can:
                  </p>
                  <ul>
                    <li><i className="fas fa-check" />Define success profiles based on growth and adaptability</li>
                    <li><i className="fas fa-check" />Run structured assessments across roles and locations</li>
                    <li><i className="fas fa-check" />Compare talent with consistent scoring and <br />benchmarks</li>
                    <li><i className="fas fa-check" />Visualise trends and readiness at scale</li>
                  </ul>
                  <p className='m-t-24' style={{ fontSize:'16px' }}>
                  These insights help you act early, build talent pipelines, and <br />
                  invest in the right people before competitors do.
                  </p>

                </div>
              </div>
            </div> 

          </section>
      </div>

      <div className="section-gray single-triangle triangle-right" style={{position: 'relative'}}>
          <section className='p-t-50 p-b-50'>
            <div className='ai-interview-start'>
              <h1>Find the Leaders You <br />Didn't Know You Had</h1>
              <h4>Shine a spotlight on internal potential and invest in your future leaders.  </h4>
                <div className="ban-text-start-demo">
                <div className={`ban-link`}>
                  <Link onClick={() => {
                    document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                    accesslog('talent-management/high-potential-identification', 'button_talk_to_an_expert');
                  }} className="try">{translate(globalGetLanguages,'BUTTON_TALK_EXPERT')}</Link>
                  <a href={weeklyDemoData.webinar_link} target="_blank" className={`request-demo-logged${weeklyDemoData.webinar_link != null ? '' : ' hide'}`}
                    onClick={() => accesslog('talent-management/high-potential-identification', 'button_register_for_demo')}
                  >Register for Demo</a>
                </div>
              </div>

            </div>
          </section>
      </div>

        
        <FooterNew />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
	return {
    globalGetLanguages:state.globalGetLanguages,
    user: state.user,
    weeklyDemoData: state.weeklyDemo.weeklyDemoData
	}
}

const mapDispatchToProps = (dispatch) => {
  return {
    usersGetDetailAsync: (user) => dispatch(usersGetDetailAsync(user)),
    getWeeklyDemoDataAsync: () => dispatch(getWeeklyDemoDataAsync())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HighPotential)
